import { Button } from "@/components/ui/button";
import { ClipboardCopy } from "lucide-react";
import { toast } from "sonner";

const gamme = (sectors = []) => {
  const r = new Set(sectors.map((s) => s.range_key));
  return [r.has("van") && "Équestre", r.has("prosport") && "Remorque"].filter(Boolean).join(" + ") || "—";
};

export const resellerLine = (r) => [r.name, r.company || "", r.email, r.dealer_type === "agent" ? "Agent" : "Concessionnaire",
  r.exclusive ? "Exclusif" : "Non exclusif", gamme(r.sectors)].join(" ; ");

export const CopyResellerList = ({ rows }) => {
  const copy = async () => {
    const text = ["NOM Prénom ; Société ; Email ; Statut ; Exclusivité ; Gamme", ...rows.map(resellerLine)].join("\n");
    try { await navigator.clipboard.writeText(text); toast.success(`${rows.length} revendeur(s) copiés`); }
    catch { toast.error("Copie impossible sur ce navigateur"); }
  };
  return (
    <Button variant="outline" className="gap-1" onClick={copy} disabled={!rows.length} title="Copier la liste affichée (statut, exclusivité, gamme)" data-testid="copy-reseller-list">
      <ClipboardCopy className="w-4 h-4" /> Copier la liste
    </Button>
  );
};
